import type { MailboxInfo } from 'owa-client-types';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isOfflineSyncEnabled } from './isOfflineSyncEnabled';

export function isOfflineCalendarDataEnabled(mailboxInfo?: MailboxInfo) {
    return isOfflineSyncEnabled(mailboxInfo) && isFeatureEnabled('fwk-offline-calendar');
}
